import { render, staticRenderFns } from "./_cpiCustomList.vue?vue&type=template&id=7f241c56&lang=pug"
import script from "./_cpiCustomList.vue?vue&type=script&lang=js"
export * from "./_cpiCustomList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports